require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-front-end-libraries-projects-build-a-drum-machine.json") })
        }
      }, "path---front-end-libraries-front-end-libraries-projects-build-a-drum-machine");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-front-end-libraries-projects-build-a-drum-machine!./.cache/json/front-end-libraries-front-end-libraries-projects-build-a-drum-machine.json
// module id = 2018
// module chunks = 231608221292675